import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'lib-countdown-timer',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './countdown-timer.component.html',
  styleUrls: ['./countdown-timer.component.scss'],
})
export class CountdownTimerComponent implements OnInit, OnDestroy {
  @Input() duration = 120;
  @Output() finished = new EventEmitter<void>();

  minutes = '00';
  seconds = '00';
  private intervalId: any;
  private remaining = 0;

  ngOnInit() {
    this.startCountdown();
  }

  ngOnDestroy() {
    this.clearTimer();
  }

  private updateTime() {
    const m = Math.floor(this.remaining / 60);
    const s = this.remaining % 60;
    this.minutes = m.toString().padStart(2, '0');
    this.seconds = s.toString().padStart(2, '0');
  }

  private clearTimer() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
  }

  startCountdown(duration?: number) {
    this.clearTimer();
    this.remaining = duration ?? this.duration;
    this.updateTime();

    this.intervalId = setInterval(() => {
      this.remaining--;
      this.updateTime();

      if (this.remaining <= 0) {
        this.clearTimer();
        this.finished.emit();
      }
    }, 1000);
  }

  reset() {
    this.startCountdown();
  }

  stop() {
    this.clearTimer();
    this.remaining = 0;
    this.updateTime();
  }
}
